import React from 'react';
import DateHelpers from '@/core/helpers/DateHelper';

interface IProps {
  schedule?: any;
  isVirtual: boolean;
}
const ScheduleBlock = (props: IProps) => {
  const { schedule, isVirtual } = props;
  return (
    <>
      {schedule?.length === 0 ? (
        <div>
          <div>
            <p style={{ display: 'flex' }}>Horario: --</p>
          </div>
        </div>
      ) : (
        <>
          {isVirtual ? (
            <p style={{ display: 'flex' }}>
              Horario: Disponible 24/7 por UTP+ Class
            </p>
          ) : (
            <p style={{ display: 'flex' }}>
              Horario:
              <ul>
                {schedule.map((sch: any, i: any) => (
                  <li key={i}>
                    {DateHelpers.getDayNameOfWeek(Number(sch?.day), true)}:{' '}
                    {sch?.startDate} - {sch?.endDate}
                  </li>
                ))}
              </ul>
            </p>
          )}
        </>
      )}
    </>
  );
};

export default ScheduleBlock;
